import { render } from "./MemberTransferPoint.vue?vue&type=template&id=53320f3e&scoped=true"
import script from "./MemberTransferPoint.vue?vue&type=script&lang=js"
export * from "./MemberTransferPoint.vue?vue&type=script&lang=js"

import "./MemberTransferPoint.vue?vue&type=style&index=0&id=53320f3e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53320f3e"

export default script